var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.47656 7.56023C9.78656 3.96023 11.6366 2.49023 15.6866 2.49023H15.8166C20.2866 2.49023 22.0766 4.28023 22.0766 8.75023V15.2702C22.0766 19.7402 20.2866 21.5302 15.8166 21.5302H15.6866C11.6666 21.5302 9.81656 20.0802 9.48656 16.5402",
    stroke: "#2F405A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5831 12H4.20312",
    stroke: "#2F405A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42812 8.65039L3.07812 12.0004L6.42812 15.3504",
    stroke: "#2F405A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutSvg);
export default __webpack_public_path__ + "static/media/logout_svg.9187f8eceebdf0df2ab6e44e5724efaf.svg";
export { ForwardRef as ReactComponent };